export default __webpack_public_path__ + "static/media/polgot-screenshot-05.db9a9e7b.png";